import React, { useState } from 'react'
import { JobRoleWholeFlex, SectionName } from '../JobRoles/PageHeader/style'
import { LeftSection } from '../Placement/style'
import { TopHeadingTPO } from '../TPORequests/style'
import { Col, Row } from 'antd'
import StudentIcon from '../../components/icons/ReportsIcons/StudentIcon'
import Button from '../../components/Button'
import ManagementIcon from '../../components/icons/ReportsIcons/ManagementIcon'
import {
  CardItem,
  ButtonStyle,
  StyledDiv,
  ListItem,
  Heading,
  RoundImage,
} from '../Reports/Styles/Style'
import { useNavigate } from 'react-router-dom'
import { reportDataJson } from '../Reports/Partials/CommonData/reportData'

const iconMap = {
  StudentIcon: StudentIcon,
  ManagementIcon: ManagementIcon,
}

function ReportsIndex({ getYear }) {
  const navigate = useNavigate()

  const handleStudentReport = category => {
    navigate(`/reports/studentreports?category=${category}`)
  }

  const reportData = reportDataJson?.map(item => ({
    ...item,
    imgPath: iconMap[item.imgPath] || StudentIcon,
  }))

  return (
    <div>
      <JobRoleWholeFlex>
        <LeftSection>
          <SectionName>
            <TopHeadingTPO>Reports</TopHeadingTPO>
          </SectionName>
        </LeftSection>
        <Row gutter={[24, 24]} style={{ marginTop: '40px' }}>
          {reportData?.map(category => (
            <Col
              key={category?.category}
              xs={{
                flex: '100%',
              }}
              sm={{
                flex: '50%',
              }}
              md={{
                flex: '40%',
              }}
              lg={{
                flex: '20%',
              }}
              xl={{
                flex: '10%',
              }}
            >
              <CardItem>
                <RoundImage>
                  {React.createElement(category?.imgPath)}
                </RoundImage>
                <StyledDiv style={{ top: '160px' }}>
                  <Heading> This includes</Heading>
                  {category?.reports?.map(item => (
                    <ListItem key={item?.id}>
                      <li
                        style={
                          item?.title === 'Custom report'
                            ? { fontWeight: 'bold' }
                            : {}
                        }
                      >
                        {item?.title}
                      </li>
                    </ListItem>
                  ))}
                </StyledDiv>
                <ButtonStyle>
                  <Button.Primary
                    text={'Generate'}
                    onClick={() => handleStudentReport(category.category)}
                  />
                </ButtonStyle>
              </CardItem>
            </Col>
          ))}
        </Row>
      </JobRoleWholeFlex>
    </div>
  )
}

export default ReportsIndex
